import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import pdf from "../../Assets/Cv_For_PGJB.pdf";

function Resume() {



  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Complete web Development Course"
              date="June 2020 - Present"
              content={[
              "I learnt here Html, css, JavaScript, Bootstrap, React.js, git, React-Bootstrap, Meterial-ui Crud Operation(node.js, express.js, mongodb), firebase, netlify, heroku"
              ]}
            />
           
          </Col>
          
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="Dhaka College Under University of Dhaka "
              date="2020 - Present"
              content={[`CGPA: ""`]}
            />
            <Resumecontent
              title=" 12TH BOARD [Ispahani Public School and College]"
              date="2016 - 2019"
              content={["GPA: 4.67 Out of 5"]}
            />
            <Resumecontent
              title="10TH BOARD [Islamia Alia Kamil Madrasha] "
              date="2013 - 2016"
              content={["GPA: 5 Out of 5"]}
            />

          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
